import { getStartLineNumber, getEndLineNumber } from '~/notes/components/multiline_comment_utils';
import ToggleRepliesWidget from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/toggle_replies_widget.vue?vue3';
import { SYSTEM_NOTE } from '~/notes/constants';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import PlaceholderNote from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/placeholder_note.vue?vue3';
import PlaceholderSystemNote from './placeholder_system_note.vue';
import DraftNote from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/draft_note.vue?vue3';
import SystemNote from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/system_note.vue?vue3';
import NoteableNote from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/noteable_note.vue?vue3';
import LineRangeHeadline from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/line_range_headline.vue?vue3';
export default {
    name: 'DiscussionNotes',
    SYSTEM_NOTE,
    components: {
        DraftNote,
        SystemNote,
        NoteableNote,
        PlaceholderNote,
        PlaceholderSystemNote,
        ToggleRepliesWidget,
        LineRangeHeadline
    },
    mixins: [
        glSlotsMixin
    ],
    inject: {
        userPermissions: {
            type: Object
        }
    },
    props: {
        notes: {
            type: Array,
            required: true
        },
        expanded: {
            type: Boolean,
            required: false,
            default: true
        },
        individual: {
            type: Boolean,
            required: false,
            default: false
        },
        timelineLayout: {
            type: Boolean,
            required: false,
            default: false
        },
        isLastDiscussion: {
            type: Boolean,
            required: false,
            default: false
        },
        canResolve: {
            type: Boolean,
            required: false,
            default: false
        },
        isResolved: {
            type: Boolean,
            required: false,
            default: false
        },
        isResolving: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'cancel-editing',
        'note-edited',
        'resolve',
        'start-editing',
        'start-replying',
        'toggle-discussion-replies'
    ],
    computed: {
        hasReplies () {
            return Boolean(this.replies.length);
        },
        replies () {
            return this.notes.slice(1).filter((note)=>!note.isDraft);
        },
        draftReplies () {
            return this.notes.slice(1).filter((note)=>note.isDraft);
        },
        firstNote () {
            return this.notes[0];
        },
        lineRange () {
            return this.firstNote.position?.line_range;
        },
        showMultiLineComment () {
            const startLine = getStartLineNumber(this.lineRange);
            const endLine = getEndLineNumber(this.lineRange);
            return Boolean(startLine && endLine && startLine !== endLine);
        }
    }
};
